import {
  Toast,
  CellGroup,
  Field,
  Icon,
  Dialog,
  NumberKeyboard,
  Area,
  Popup,
  Col,
  Row,
  Picker,
  Pagination,
  NavBar,
  List,
  PullRefresh,
  Tab,
  Tabs,
  Overlay,
  Loading,
  PasswordInput,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  IndexBar,
  IndexAnchor,
  Tag,
  Lazyload,
  Calendar,
  Search,
  RadioGroup,
  Radio,
  Form,
  Button,
  Cell,
  Tabbar,
  TabbarItem,
  Uploader,
  ImagePreview,
  Image,
  DatetimePicker,
  Switch,
  Step,
  Steps,
  Collapse,
  CollapseItem,
  ShareSheet,
  ActionSheet,
  Empty,
} from 'vant'

const components = [
  Toast,
  CellGroup,
  Field,
  Icon,
  Dialog,
  NumberKeyboard,
  Area,
  Popup,
  Col,
  Row,
  Picker,
  Pagination,
  NavBar,
  List,
  PullRefresh,
  Tab,
  Tabs,
  Overlay,
  Loading,
  PasswordInput,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  IndexBar,
  IndexAnchor,
  Tag,
  Lazyload,
  Calendar,
  Search,
  RadioGroup,
  Radio,
  Form,
  Button,
  Cell,
  Tabbar,
  TabbarItem,
  Uploader,
  ImagePreview,
  Image,
  DatetimePicker,
  Switch,
  Step,
  Steps,
  Collapse,
  CollapseItem,
  ShareSheet,
  ActionSheet,
  Empty,
]
// 注册组件
const install = Vue => {
  components.forEach(component => {
    Vue.use(component)
  })
}
/**
 * 引入vant ui 组件
 */
export default {
  install
}
